import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableShippingOptionsForRateShoppers = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableShippingOptionsForRateShoppers);
};
